import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled(Box, { shouldForwardProp: (p) => p !== "expanding" })(({ expanding }) => ({
  background: "#fff",
  borderRadius: 8,
  padding: expanding ? 0 : "10px 12px",
  boxShadow: expanding ? "none" : "0 3px 10px rgba(44,62,80,0.12)",
  borderLeft: expanding ? "none" : "3px solid #2ec4b6",
  maxHeight: expanding ? 0 : 160,
  marginTop: expanding ? -8 : 0,
  opacity: expanding ? 0 : 1,
  overflow: "hidden",
  textAlign: "left",
  transition: [
    "max-height 0.55s cubic-bezier(.4,0,.2,1)",
    "padding 0.55s cubic-bezier(.4,0,.2,1)",
    "margin 0.55s cubic-bezier(.4,0,.2,1)",
    "opacity 0.4s ease",
  ].join(", "),
}));

const Label = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  fontSize: "0.72rem",
  letterSpacing: "0.2em",
  color: "#1a7a72",
  textTransform: "uppercase",
  fontWeight: 900,
});

const Sub = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  fontSize: "1rem",
  color: "#1c1c1c",
  fontWeight: 700,
  lineHeight: 1.2,
  margin: "3px 0 6px",
});

const Winner = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  fontSize: "1.05rem",
  color: "#222",
  lineHeight: 1,
});

const Detail = styled(Typography)({
  fontSize: "0.65rem",
  color: "#5f5f5f",
  marginTop: 4,
  lineHeight: 1.3,
});

const PhoneListItem = ({ superlative, expanding }) => (
  <Root expanding={expanding}>
    <Label>{superlative.header}</Label>
    <Sub>{superlative.subhead}</Sub>
    <Winner>{superlative.winner}</Winner>
    {superlative.winnerDetail && <Detail>{superlative.winnerDetail}</Detail>}
  </Root>
);

export default PhoneListItem;
